import React from 'react';
import SetUp from './set_up/set_up';
import General from './general/general';
import ContactUs from './contact_us/contact_us';
import scrollPositionFix from '../../services/scroll_position_fix';

import './faq.scss';

export default class FAQ extends React.Component {
  componentDidMount() {
    scrollPositionFix();
  }

  componentDidUpdate() {
    scrollPositionFix();
  }

  render() {
    return (
      <div className="faq">
        <div className="faq-container">
          <div className="faq-heading">
            Frequently Asked Questions
          </div>

          <SetUp />

          <General />

          <ContactUs />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/faq/faq.jsx